const error = {
    sessionExpired: '登录已过期，请重新登录',
    noPermission: '没有权限访问该资源',
    resourceNotFound: '请求的资源不存在',
    serverError: '服务器内部错误',
    requestFailed: '请求失败',
    networkError: '网络连接超时或服务器异常',
  }

export default error
